import { Graphics } from "pixi.js";

export class Shape {

    static selectionLineStyle = [2, 0x4F84C4, 1];

    static circles = {};

    static createCircle(x, y, radius = 25, colorArgs = [0xDE3249, 1], lineStyleArgs = [0], from = null) {
        const tint = colorArgs[0];
        colorArgs[0] = 0xFFFFFF;

        const circle = new Graphics();
        circle.lineStyle(...lineStyleArgs);
        circle.beginFill(...colorArgs);
        circle.drawCircle(0, 0, radius);
        circle.endFill();

        circle.tint = tint;
        circle.position.set(x, y);

        return circle;
    }

    /**
     *
     * @param x1
     * @param y1
     * @param x2
     * @param y2
     * @param lineStyleArgs
     * @param shapeBackground
     * @param shapeBackgroundAlpha
     * @returns {Graphics}
     */
    static createRectangle(x1, y1, x2, y2, lineStyleArgs = [2, 0x000000, 1], shapeBackground = 0x000000, shapeBackgroundAlpha = 0) {
        const rectangle = new Graphics();
        const tint = shapeBackground;
        shapeBackground = 0xFFFFFF;
        rectangle.beginFill(shapeBackground, shapeBackgroundAlpha);
        rectangle.lineStyle(...lineStyleArgs);
        rectangle.drawRect(x1, y1, x2 - x1, y2 - y1);

        rectangle.tint = tint;

        rectangle.endFill();
        return rectangle;
    }

    static createAbstractShape(points, lineStyleArgs = [2, 0x000000, 1], fillArgs = [0x000000, 0]) {
        const rectangle = new Graphics();
        rectangle.beginFill(...fillArgs);
        rectangle.lineStyle(...lineStyleArgs);
        points.forEach((point, i) => {
            if (i === 0 || point.move) {
                rectangle.moveTo(point.x, point.y);
            } else {
                rectangle.lineTo(point.x, point.y);
            }
        });
        rectangle.closePath();
        rectangle.endFill();
        return rectangle;
    }
}